import { render, staticRenderFns } from "./UserInfoColumn.vue?vue&type=template&id=0978b3ad&scoped=true"
import script from "./UserInfoColumn.vue?vue&type=script&lang=js"
export * from "./UserInfoColumn.vue?vue&type=script&lang=js"
import style0 from "./UserInfoColumn.vue?vue&type=style&index=0&id=0978b3ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0978b3ad",
  null
  
)

export default component.exports